type BoxesIconProps = {
  fillColor: string;
  width?: number;
  height?: number;
};

export default function BoxesIcon({
  fillColor,
  width = 18,
  height = 16,
}: BoxesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill="none"
    >
      <path
        d="M16.6562 8.9375H14.3125V11.75L13.375 11.126L12.4375 11.75V8.9375H10.0938C9.83594 8.9375 9.625 9.14844 9.625 9.40625V15.0312C9.625 15.2891 9.83594 15.5 10.0938 15.5H16.6562C16.9141 15.5 17.125 15.2891 17.125 15.0312V9.40625C17.125 9.14844 16.9141 8.9375 16.6562 8.9375ZM5.40625 7.0625H11.9688C12.2266 7.0625 12.4375 6.85156 12.4375 6.59375V0.96875C12.4375 0.710938 12.2266 0.5 11.9688 0.5H9.625V3.3125L8.6875 2.68848L7.75 3.3125V0.5H5.40625C5.14844 0.5 4.9375 0.710938 4.9375 0.96875V6.59375C4.9375 6.85156 5.14844 7.0625 5.40625 7.0625ZM7.28125 8.9375H4.9375V11.75L4 11.126L3.0625 11.75V8.9375H0.71875C0.460938 8.9375 0.25 9.14844 0.25 9.40625V15.0312C0.25 15.2891 0.460938 15.5 0.71875 15.5H7.28125C7.53906 15.5 7.75 15.2891 7.75 15.0312V9.40625C7.75 9.14844 7.53906 8.9375 7.28125 8.9375Z"
        fill={fillColor}
      />
    </svg>
  );
}
